// Unpublished Work © 2020-2022 Deere & Company

export const CurrenciesMap = {
    'da-DK': 'EUR',
    'de-AT': 'EUR',
    'de-CH': 'CHF',
    'de-DE': 'EUR',
    'de-LU': 'EUR',
    'el-GR': 'EUR',
    'en-AU': 'AUD',
    'en-CA': 'CAD',
    'en-GB': 'GBP',
    'en-IE': 'EUR',
    'en-NZ': 'NZD',
    'en-US': 'USD',
    'es-AR': 'ARS',
    'es-ES': 'EUR',
    'fi-FI': 'EUR',
    'fr-CA': 'CAD',
    'fr-CH': 'UAH',
    'fr-FR': 'EUR',
    'hu-HU': 'HUF',
    'it-CH': 'UAH',
    'it-IT': 'EUR',
    'nl-BE': 'EUR',
    'nl-NL': 'EUR',
    'no-NO': 'NOK',
    'pl-PL': 'PLN',
    'pt-BR': 'BRL',
    'pt-PT': 'EUR',
    'ro-RO': 'RON',
    'ru-RU': 'RUB',
    'ru-UA': 'UAH',
    'sv-SE': 'SEK',
    'th-TH': 'THB',
    'tr-TR': 'TRY',
    'zh-CN': 'CNY'
};

export const DEFAULT_LOCALE = 'en-US';
export const DEFAULT_CURRENCY = 'USD';

const hasValue = (entity, value) => entity && entity[value];

const getLocaleBasedOnConfigurationAndUserDefaults = (configuration, user) => {
    if (hasValue(configuration, 'locale')) {
        return configuration.locale;
    } else if (hasValue(user, 'locale')) {
        return user.locale;
    }

    return DEFAULT_LOCALE;
};

const getCurrencyBasedOnConfigurationAndUserDefaults = (configuration, user) => {
    if (hasValue(configuration, 'currency')) {
        return configuration.currency;
    } else if (hasValue(user, 'locale')) {
        return CurrenciesMap[user.locale];
    }

    return DEFAULT_CURRENCY;
};

export const getLocaleAndCurrency = (configuration, user) => ({
    locale: getLocaleBasedOnConfigurationAndUserDefaults(configuration, user),
    currency: getCurrencyBasedOnConfigurationAndUserDefaults(configuration, user)
});
